import { API, authHeaders } from "./supabase";

/* Web Push helpers. Permission must be requested from a user gesture (call subscribe() inside a click handler). */
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;

export const pushSupport = () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return { ok: false, reason: isIOS() && !standalone() ? "ios_install" : "unsupported" };
  }
  return { ok: true, brave: !!navigator.brave };
};
export const permission = () => ("Notification" in window ? Notification.permission : "denied");

const toKey = (b64) => { const s = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from(s, (c) => c.charCodeAt(0)); };

export const currentSubscription = async () => {
  if (!pushSupport().ok) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
};

export const subscribePush = async () => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: perm === "denied" ? "blocked" : "dismissed" };
  const { key, enabled } = await (await fetch(`${API}/push/vapid-public-key`)).json();
  if (!enabled) return { ok: false, reason: "server_disabled" };
  const reg = await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(key) }));
  const r = await fetch(`${API}/push/subscribe`, { method: "POST", headers: { "Content-Type": "application/json", ...(await authHeaders()) }, body: JSON.stringify({ ...sub.toJSON(), user_agent: navigator.userAgent }) });
  if (!r.ok) return { ok: false, reason: r.status === 503 ? "server_disabled" : "server_error" };
  return { ok: true, ...(await r.json()) };
};

export const unsubscribePush = async () => {
  const sub = await currentSubscription();
  if (!sub) return { ok: true, devices: null };
  const r = await fetch(`${API}/push/subscribe`, { method: "DELETE", headers: { "Content-Type": "application/json", ...(await authHeaders()) }, body: JSON.stringify({ endpoint: sub.endpoint }) });
  await sub.unsubscribe().catch(() => null);
  return { ok: r.ok, ...(r.ok ? await r.json() : {}) };
};

export const NUDGE_KEY = "dropit-alerts-nudge-dismissed";
